var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-tips"},[(_vm.appConfig.appId == '1018')?_c('div',{staticClass:"tips-1018"},[_c('p',[_vm._v(_vm._s(_vm.$t('ruTips1')))]),_c('p',[_vm._v(_vm._s(_vm.$t('ruTips2')))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }